<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">企业信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <el-form :inline="true" label-position="right" label-width="150px">
        <el-form-item label="企业名称" class="width48">
          <div class="ml-80">{{ enterpriseForm.name }}</div>
        </el-form-item>
        <el-form-item label="企业身份" class="width48">
          <div class="ml-80">{{ getOrgType(enterpriseForm.orgType) }}</div>
        </el-form-item>
        <!-- 电站运营商 -->
        <template v-if="enterpriseForm.orgType==0">
          <el-form-item label="运营商属性" class="width48">
            <div class="ml-80">{{ enterpriseForm.attr==0?'自营':enterpriseForm.attr==1?'加盟':enterpriseForm.attr==2?'互联互通':'--' }}</div>
          </el-form-item>
          <el-form-item label="运营商名称" class="width48">
            <div class="ml-80">{{ enterpriseForm.operatorName }}</div>
          </el-form-item>
          <el-form-item label="运营商秘钥" class="width48">
            <div class="ml-80">{{ enterpriseForm.operatorSecret }}</div>
          </el-form-item>
          <el-form-item label="消息秘钥" class="width48">
            <div class="ml-80">{{ enterpriseForm.dataSecret }}</div>
          </el-form-item>
          <el-form-item label="初始化向量" class="width48">
            <div class="ml-80">{{ enterpriseForm.dataSecretIv }}</div>
          </el-form-item>
          <el-form-item label="签名秘钥" class="width48">
            <div class="ml-80">{{ enterpriseForm.sigSecret }}</div>
          </el-form-item>
        </template>
        <!-- 车辆机构 -->
        <!-- <template v-if="enterpriseForm.orgType==1">
          <el-form-item label="企业前缀" class="width48">
            <div class="ml-80">{{ enterpriseForm.prefix }}</div>
          </el-form-item>
        </template> -->
        <!-- 流量方 -->
        <template v-if="enterpriseForm.orgType==2">
          <el-form-item label="账号" class="width48">
            <div class="ml-80">{{ enterpriseForm.car.loginName }}</div>
          </el-form-item>
          <el-form-item label="用户名" class="width48">
            <div class="ml-80">{{ enterpriseForm.car.username }}</div>
          </el-form-item>
          <el-form-item label="手机号码" class="width48">
            <div class="ml-80">{{ enterpriseForm.car.mobile }}</div>
          </el-form-item>
        </template>
        <el-form-item label="企业注册地址" class="width48">
          <div class="ml-80">{{ enterpriseForm.contactAddress }}</div>
        </el-form-item>
        <el-form-item label="统一社会信用代码" class="width48">
          <div class="ml-80">{{ enterpriseForm.code }}</div>
        </el-form-item>
        <el-form-item label="归属城市" class="width48">
          <el-cascader style="margin-left: 120px;" v-if="enterpriseForm.cityCode && enterpriseForm.cityCode.length>0" ref="three" v-model="enterpriseForm.cityCode" :options="optionsThree" :props="{ checkStrictly: true }" disabled />
          <span style="margin-left: 120px;"  v-else>--</span>
        </el-form-item>
        <el-form-item label="签约时间" class="width48">
          <div class="ml-80">{{ enterpriseForm.signStartTime?(enterpriseForm.signStartTime+"&nbsp;&nbsp;至&nbsp;&nbsp;"+enterpriseForm.signEndTime):"" }}</div>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card v-if="enterpriseForm.orgType===1" shadow="never">
      <div slot="header">
        <span class="title">充电限制</span>
      </div>
      <el-form ref="limitStationForm" :inline="true" :model="enterpriseForm" label-width="130px">
        <el-form-item label="充电阈值" class="width48">
          <div class="ml-80" v-show="enterpriseForm.threshold || enterpriseForm.threshold===0">{{ enterpriseForm.threshold }}元</div>
        </el-form-item>
        <el-form-item label="是否限制充电站" class="width48">
          <div class="ml-80">{{ enterpriseForm.isLimit==1?'是':'否' }}</div>
        </el-form-item>
        <template v-if="enterpriseForm.isLimit===1">
          <el-form-item label="限制电站" prop="limitStation" style="width:90%">
            <div class="ml-80">{{ enterpriseForm.limitStation=='org'?'运营商':enterpriseForm.limitStation=='station'?'电站':'' }}</div>
            <!-- 选择运营商 -->
            <div v-show="enterpriseForm.limitStation==='org'" class="border">
              <el-tree
                ref="treeOperator"
                :data="operatorTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="enterpriseForm.orgIds"
              />
            </div>
            <!-- 选择电站 -->
            <div v-show="enterpriseForm.limitStation==='station'" class="border">
              <el-tree
                ref="treeStation"
                :data="stationTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="enterpriseForm.stationIds"
              />
            </div>
          </el-form-item>
        </template>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">其他信息</span>
      </div>
      <div class style="margin-top:20px;">
        <el-form :inline="true" label-position="right" label-width="150px">
          <el-form-item label="联系人" class="width48">
            <div class="ml-80">{{ enterpriseForm.contactUser }}</div>
          </el-form-item>
          <el-form-item label="联系方式" class="width48">
            <div class="ml-80">{{ enterpriseForm.contactNum }}</div>
          </el-form-item>
          <el-form-item label="联系地址" class="width48">
            <div class="ml-80">{{ enterpriseForm.contactAddress }}</div>
          </el-form-item>
          <el-form-item label="联系邮箱" class="width48">
            <div class="ml-80">{{ enterpriseForm.email }}</div>
          </el-form-item>
          <el-form-item label="营业执照" class="width48">
            <img :src="enterpriseForm.businessLicense" class="ml-80 image">
          </el-form-item>
          <el-form-item label="备注说明" class="width48">
            <div class="ml-80">{{ enterpriseForm.remark }}</div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { provinceAndCityData } from 'element-china-area-data'
import { treeDisabled } from '@/utils/tool'
import { HOST } from '@/utils/host'
export default {
  name: 'Chongdianqiangxiangqing',
  components: {},
  data() {
    return {
      optionsThree: provinceAndCityData,
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      operatorTreeData: [], // 运营商树的全部数据
      stationTreeData: [], // 电站树的全部数据
      // 企业信息
      enterpriseForm: {
        name: '', // 企业名称
        orgType: 0, // 企业身份

        threshold: '', // 充电阈值
        isLimit: 1, // 是否限制电站
        limitStation: '', // 限制电站
        orgIds: [],
        stationIds: [],

        // 下面是分类的
        operatorName: '', // 运营商名称
        attr: 0, // 运营商属性
        // prefix: '', // 企业前缀
        car: {
          loginName: '', // 账号
          username: '', // 用户名
          password: '', // 密码
          mobile: ''// 手机号码
        },

        // 下面是公共的，都有的
        address: '', // 企业注册地址
        code: '', // 统一社会信用代码
        cityCode: [], // 归属城市
        signTime: [], // 签约时间

        contactUser: '', // 联系人
        contactNum: '', // 联系方式
        contactAddress: '', // 联系地址
        email: '', // 联系邮箱
        businessLicense: '', // 营业执照
        remark: ''// 备注说明
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const data = {
        id: this.$route.query.data
      }
      this.$store.dispatch('form/handle', {
        url: '/org/getDataDetail',
        data: data,
        method: 'get',
        callback: (resp) => {
          this.enterpriseForm = JSON.parse(JSON.stringify(resp))
          this.enterpriseForm.cityCode = resp.city ? resp.city.split(',') : [],
		  this.enterpriseForm.threshold = resp.chargingThreshold
          if (resp.orgType === 1) {
            if (resp.stationOrg === 'org') {
              this.enterpriseForm.isLimit = 1
              this.enterpriseForm.limitStation = 'org'
              this.enterpriseForm.orgIds = resp.limitStationIds.split(',')
            } else if (resp.stationOrg === 'station') {
              this.enterpriseForm.isLimit = 1
              this.enterpriseForm.limitStation = 'station'
              this.enterpriseForm.stationIds = resp.limitStationIds.split(',')
            } else {
              this.enterpriseForm.isLimit = 2
            }
          }
          // 营业执照
          this.enterpriseForm.businessLicense = HOST + '/oss?objectName=' + resp.businessLicense + '&token=' + window.localStorage.getItem('token')
          console.log(this.enterpriseForm)
        }
      })
      this.loadTree()
    })
  },
  methods: {
    // 加载全部运营商、电站数据
    loadTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: {
          treeDepth: 'ORG'
        },
        callback: resp => {
          this.operatorTreeData = treeDisabled(resp, true)
        }
      })
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: {
          treeDepth: 'STATION'
        },
        callback: resp => {
          this.stationTreeData = treeDisabled(resp, true)
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    },
    getOrgType(val) {
      if (val === 0) {
        // 电站运营商
        return '电站运营商'
      } else if (val === 1) {
        // 车辆机构
        return '车辆机构'
      } else if (val === 2) {
        // 流量方
        return '流量方'
      }
    }
  }
}
</script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .width48{
      width: 96%;
  }
  .notWrap{
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
  .ml-80{
    margin-left: 120px;
  }
  .image{
    width: 170px;
    height: 170px;
  }
  /deep/.width48 .el-cascader.is-disabled{
    .el-input.is-disabled{
      .el-input__inner{
        border:none;
        background:#fff;
        padding: 0px;
        color: #333;
      }
      .el-input__suffix{
        display:none
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/organManagement/operatorDetail.vue